$(document).ready(function () {
    var items    = $('.history-item .info .show-details');

    items.click(function(){
        var elem = $(this),
            dropdown = elem.parent().next(),
            dropdowns = $('.history-item .dropdown'),
            index = dropdowns.index(dropdown);
        
        elem.toggleClass('active');
        dropdowns.splice(index, 1);
        dropdowns.stop();
        dropdowns.slideUp(300);
        dropdown.stop();
        dropdown.slideToggle(300);
    })
    
});